import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export class ChildProfileRegistrationState extends Record<{
    isEditing: boolean;
    isUpdating: boolean;
    isShowingChildGroupMoveModal: boolean;
    isShowingSettingMoveModal: boolean;
    isCancellingSettingMove: boolean;
}>({
    isEditing: false,
    isUpdating: false,
    isShowingChildGroupMoveModal: false,
    isShowingSettingMoveModal: false,
    isCancellingSettingMove: false,
}) {}

export default makeReducer<ChildProfileRegistrationState>(
    [
        match(Actions.setEdit, (state, {payload}) =>
            state.merge({
                isEditing: payload.shouldEdit,
            }),
        ),
        match(Actions.updateStartLeave, state =>
            state.merge({
                isUpdating: true,
            }),
        ),
        match(Actions.updateStartLeaveSuccess, state =>
            state.merge({
                isUpdating: false,
                isEditing: false,
            }),
        ),
        match(Actions.updateStartLeaveFailed, state =>
            state.merge({
                isUpdating: false,
                isEditing: false,
            }),
        ),
        match(Actions.cancelChildMove, state =>
            state.merge({
                isCancellingSettingMove: true,
            }),
        ),
        match(Actions.cancelChildMoveSuccess, state =>
            state.merge({
                isCancellingSettingMove: false,
            }),
        ),
        match(Actions.cancelChildMoveFailed, state =>
            state.merge({
                isCancellingSettingMove: false,
            }),
        ),
        match(Actions.setShowChildGroupMoveModal, (state, {payload}) =>
            state.merge({
                isShowingChildGroupMoveModal: payload.show,
            }),
        ),
        match(Actions.setShowSettingMoveModal, (state, {payload}) =>
            state.merge({
                isShowingSettingMoveModal: payload.show,
            }),
        ),
    ],
    new ChildProfileRegistrationState(),
);
